import PxtoremPlugin from './pxtorem';
import UBTPlugin from './ubt';

export default {
  install(Vue) {
    Vue.use(PxtoremPlugin);
    Vue.use(UBTPlugin);
  },
};
